module.exports = __webpack_public_path__ + "img/women-s-black-crew-neck-t-shirt-3249240.ca6c9620.jpg";